/* FT PLP v3: sticky toolbar offset + lazy load (infinite scroll) */
(function () {
  var root = document.querySelector('[data-ftp]');
  if (!root) return;
  /* experiment (RK 2026-10-20): video previews live in their own file so they can be switched off by deleting
     these lines; loaded from here so neither section file needs to change */
  (function () {
    var cur = document.currentScript || document.querySelector('script[src*="ft-plp-top.js"]');
    if (!cur || document.querySelector('script[data-ftp-video]')) return;
    var s = document.createElement('script');
    /* the asset URL carries THIS file's ?v=, which would serve a stale ft-plp-video.js from the CDN cache:
       VIDEO_V is bumped whenever ft-plp-video.js changes */
    var VIDEO_V = '2fddabce';
    s.src = cur.src.split('?')[0].replace('ft-plp-top.js', 'ft-plp-video.js') + '?v=' + VIDEO_V;
    s.defer = true; s.setAttribute('data-ftp-video', '');
    document.head.appendChild(s);
  })();
  function headerOffset() {
    var h = 0;
    document.querySelectorAll('header, .site-header, .header-wrapper, [data-section-type="header"], .sticky-header').forEach(function (el) {
      var cs = getComputedStyle(el), r = el.getBoundingClientRect();
      if ((cs.position === 'sticky' || cs.position === 'fixed') && r.top <= 1 && r.bottom > h && r.height < 260) h = r.bottom;
    });
    root.style.setProperty('--ftp-top', Math.round(h) + 'px');
  }
  headerOffset();
  var t = 0;
  window.addEventListener('scroll', function () { if (!t) t = setTimeout(function () { t = 0; headerOffset(); }, 150); }, { passive: true });
  window.addEventListener('resize', headerOffset);

  /* mobile: clamp the intro under the H1 to 3 lines with a Read more / Read less toggle */
  (function () {
    var intro = root.querySelector('.ftp-intro');
    if (!intro || !window.matchMedia('(max-width: 767px)').matches) return;
    intro.classList.add('is-clamped');
    if (intro.scrollHeight <= intro.clientHeight + 4) { intro.classList.remove('is-clamped'); return; }
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'ftp-intro-btn'; btn.textContent = 'Read more';
    btn.setAttribute('aria-expanded', 'false');
    intro.insertAdjacentElement('afterend', btn);
    btn.addEventListener('click', function () {
      var open = intro.classList.toggle('is-clamped') === false;
      btn.textContent = open ? 'Read less' : 'Read more';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  })();

  /* lazy load: when the end of the grid is near (or already scrolled past), fetch the next page.
     ft-plp.js does the fetch on [data-loadmore] click; the link stays as a no-JS fallback. */
  /* the wrap is looked up each time: live filtering can replace or empty it */
  function check() {
    var wrap = root.querySelector('.ftp-more-wrap');
    if (!wrap) return;
    var a = wrap.querySelector('[data-loadmore]');
    if (!a || a.classList.contains('is-busy')) return;
    if (wrap.getBoundingClientRect().top < window.innerHeight + 900) {
      a.click();
      var tries = 0, iv = setInterval(function () {
        var w = root.querySelector('.ftp-more-wrap'), b = w && w.querySelector('[data-loadmore]');
        if (!b) { clearInterval(iv); return; }
        if (!b.classList.contains('is-busy') || ++tries > 60) { clearInterval(iv); check(); }
      }, 250);
    }
  }
  var lt = 0;
  window.addEventListener('scroll', function () { if (!lt) lt = setTimeout(function () { lt = 0; check(); }, 120); }, { passive: true });
  window.addEventListener('resize', check);
  check();
})();
